import React from "react";
import Login from "../../components/Login";
import { LogOut } from "../../components/Logout";

export default function Accounts() {
  return (
    <>
      <Login />
      <LogOut />
    </>
  );
}
